import { render, staticRenderFns } from "./shopNumber.vue?vue&type=template&id=12957f23&scoped=true"
import script from "./shopNumber.vue?vue&type=script&lang=js"
export * from "./shopNumber.vue?vue&type=script&lang=js"
import style0 from "./shopNumber.vue?vue&type=style&index=0&id=12957f23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12957f23",
  null
  
)

export default component.exports